// Import and register all your controllers
import { application } from "./application"

// Import individual controllers
// ChartsController is loaded separately in charts.js for better performance
import ConditionController from "./condition_controller"
import HelloController from "./hello_controller"
import MobileMenuController from "./mobile_menu_controller"
import RequestConfigController from "./request_config_controller"

// Register controllers
application.register("condition", ConditionController)
application.register("hello", HelloController)
application.register("mobile-menu", MobileMenuController)
application.register("request-config", RequestConfigController)
